import { createContext } from 'react';

const BrowserHistoryContext = createContext();

export const { Provider, Consumer } = BrowserHistoryContext;

export default BrowserHistoryContext;
